<template>
  <div class="chart-container">
    <div class="chart__heading">
      <div class="chart__heading-title">{{ $t('chart.line.title') }}</div>
      <div class="chart__heading-subtitle">{{ $t('chart.last_12_month') }}</div>
    </div>
    <v-chart class="chart" :option="option" :autoresize="true"/>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  computed: {
    months() {
      let temp = [];

      for (let i = 0; i < this.data.months.length; i++) {
        let _temp = this.data.months[i];
        temp.push(this.$i18n.t('months.' + _temp.toString().toLowerCase()))
      }
      return temp;
    },

    option() {
      return {
        tooltip: {
          trigger: 'axis',
          formatter: "<span class='tool_tip_text start'>" + '{a0} : {c0} ' + this.$t('common.rial') + '  <span> {a1} : <span class="gold">{c1}</span> ' + this.$t('common.rial') + "</span>",
          className: "char-bar-tooltip line",
          position: 'left',

        },
        grid: {
          left: '0%',
          right: '3%',
          bottom: '14%',
          containLabel: true
        },
        legend: {
          show: false,
        },
        textStyle: {
          fontFamily: 'din-next'
        },
        color: ['transparent', '#7367F0'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.months
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: this.$t('financial.sales'),
            type: 'line',
            stack: 'Total',
            data: this.data.sales
          },
          {
            name: this.$t('financial.profit'),
            type: 'line',
            stack: 'Total',
            data: this.data.profits
          }
        ],
        media: [ // each rule of media query is defined here
          {
            query: {
              maxAspectRatio: 1
            },   // write rule here

          },
        ]
      }
    }
  }
};
</script>

<style scoped>

</style>
